<template>
  <v-container id="zonasreparto" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="success"
          inline
          title="Zonas de Reparto"
          class="px-5 py-3"
        >
          <v-card-actions>
            <v-btn @click="addPath">Añadir zona</v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              :disabled="itemEditando != null"
              @click="save"
              :loading="loadingSave"
              >Guardar</v-btn
            >
          </v-card-actions>

          <v-card-text class="px-0 pb-0">
            <v-row>
              <v-col
                v-for="(item, i) in datosZonas"
                :key="item.id"
                cols="12"
                md="4"
              >
                <v-card outlined color="lighten-3" max-width="344">
                  <v-card-title>Zona {{ item.nombre }}</v-card-title>
                  <v-card-text class="text--primary">
                    <v-text-field
                      :disabled="!item.editando"
                      v-model="item.nombre"
                      label="nombre"
                    ></v-text-field>
                    <v-row>
                      <v-col cols="6">
                        <v-checkbox
                          :disabled="!item.editando"
                          label="DOMICILIO"
                          v-model="item.siDomicilio"
                        />
                        <v-row>
                          <v-col cols="6" class="py-0">
                            <v-text-field
                              :disabled="!item.editando || !item.siDomicilio"
                              v-model="item.domicilioMinimo"
                              label="Mínimo"
                              type="number"
                              step="0.5"
                            />
                          </v-col>
                          <v-col cols="6" class="py-0">
                            <!-- <v-text-field
                              :disabled="!item.editando || !item.siDomicilio"
                              v-model="item.domicilioRecargo"
                              label="Recargo"
                              type="number"
                              step="0.5"
                              append-icon="mdi-currency-eur"
                              @click:append="openDialogMapeando(item)"
                            /> -->
                            <v-text-field
                              :disabled="!item.editando || !item.siDomicilio"
                              v-model="item.domicilioRecargo"
                              label="Recargo"
                              type="number"
                              step="0.5"
                              append-icon="mdi-currency-eur"
                              @click:append="openDialogProductoZona(item)"
                            />
                          </v-col>
                          <v-col cols="12" class="mt-0 pt-0">
                            <v-select
                              label="impuesto recargo"
                              :disabled="!item.editando || !item.siDomicilio"
                              v-model="item.impuestoRecargoDomicilio"
                              :items="
                                $store.getters['impuestos/getImpuestosSelect']
                              "
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-checkbox
                          label="RECOGIDA"
                          v-model="item.siRecogida"
                          :disabled="!item.editando"
                        />
                        <v-row>
                          <v-col cols="6" class="py-0">
                            <v-text-field
                              :disabled="!item.editando || !item.siRecogida"
                              v-model="item.recogidaMinimo"
                              label="Mínimo"
                              type="number"
                              step="0.5"
                            />
                          </v-col>
                          <v-col cols="6" class="py-0">
                            <v-text-field
                              :disabled="!item.editando || !item.siRecogida"
                              v-model="item.recogidaRecargo"
                              label="Recargo"
                              type="number"
                              step="0.5"
                            />
                          </v-col>
                          <v-col cols="12" class="mt-0 pt-0">
                            <v-select
                              label="impuesto recargo"
                              :disabled="!item.editando || !item.siRecogida"
                              v-model="item.impuestoRecargoRecogida"
                              :items="
                                $store.getters['impuestos/getImpuestosSelect']
                              "
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-row>
                        <v-color-picker
                          :disabled="!item.editando"
                          hide-inputs
                          v-model="item.colorFondo"
                        ></v-color-picker>
                      </v-row>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="showConfirm(i)" text color="danger accent-4"
                      >Eliminar zona</v-btn
                    >
                    <v-btn
                      v-if="!item.editando"
                      @click="goEditar(item, i)"
                      text
                      color="primary accent-4"
                      >Editar zona</v-btn
                    >
                    <v-btn
                      v-else
                      @click="saveZona(item, i)"
                      text
                      color="secondary accent-4"
                      >Guardar zona</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <v-sheet>
              <gmap-map
                ref="map"
                :center="centro"
                :zoom="15"
                style="width: 100%; height: 500px"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false,
                }"
              >
                <template v-for="(e, i) in paths">
                  <gmap-polygon
                    :key="i"
                    :paths="e"
                    :editable="e.editable"
                    @paths_changed="updateEdited($event)"
                    :options="opciones(i)"
                    @rightclick="handleClickForDelete"
                    ref="polygon"
                  ></gmap-polygon>
                </template>
                <template v-for="(p, i) in zonasOtros">
                  <gmap-polygon
                    :key="`zona_otros_${i}`"
                    :paths="p"
                    :editable="false"
                    :options="opcionesOtros()"
                    ref="polygon_otros_"
                    +
                    i
                  ></gmap-polygon>
                </template>

                <gmap-marker
                  :position="centro"
                  :clickable="true"
                  :draggable="false"
                ></gmap-marker>
              </gmap-map>
            </v-sheet>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogEliminar" persistent max-width="300">
      <v-card>
        <v-card-title>
          ¿Desea eliminar la zona?
          <v-spacer />

          <v-icon aria-label="Close" @click="closeDialogEliminar"
            >mdi-close</v-icon
          >
        </v-card-title>

        <v-card-text class="pb-6 pt-12 text-center">
          <v-btn class="mr-3" text @click="closeDialogEliminar">No</v-btn>

          <v-btn color="success" text @click="removeZona">Si</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMapeo">
      <v-card>
        <v-card-title>
          <span class="headline">Mapeo Recargo con Neo</span>
        </v-card-title>
        <v-card-text>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="searchNeo"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="getProductosNeo">
              <v-icon color="white">mdi-autorenew</v-icon>
            </v-btn>
            <v-btn color="success" @click="saveMapeo()">
              <v-icon color="white">mdi-floppy</v-icon>
            </v-btn>
          </v-toolbar>

          <v-data-table
            v-model="zonaMapeandoMapeo"
            item-key="Codigo"
            single-select
            :headers="headersNeo"
            :items="productosNeo"
            :loading="loadingNeo"
            :search="searchNeo"
            show-select
          ></v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="paraRecargoDialog">
      <v-card>
        <v-card-title>
          <span class="headline">Producto asociado al recargo</span>
        </v-card-title>
        <v-card-text>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="searchParaRecargo"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="getProductosNeo">
              <v-icon color="white">mdi-autorenew</v-icon>
            </v-btn>
            <v-btn color="success" @click="saveProductoRecargo()">
              <v-icon color="white">mdi-floppy</v-icon>
            </v-btn>
          </v-toolbar>
          {{ zonaParaRecargoProducto }}
          <v-data-table
            v-model="zonaParaRecargoProducto"
            item-key="id"
            single-select
            :headers="headersParaRecargo"
            :items="productosParaRecargo"
            :loading="loadingParaRecargo"
            :search="searchParaRecargo"
            show-select
          ></v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
var _ = require("lodash");
const VueGoogleMaps = require("vue2-google-maps");
function closeLoop(path) {
  return path.concat(path.slice(0, 1));
}
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyALEsXFX6frzu2iwyFgWlg1wKROwNcj52c",
    v: "3.39",
    libraries: "places",
  },
});
import { mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      paraRecargoDialog: false,
      searchParaRecargo: "",
      loadingParaRecargo: false,
      zonaParaRecargoProducto: [],
      headersParaRecargo: [
        {
          sortable: false,
          text: "Codigo",
          value: "id",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
      ],
      //
      zonaMapeandoMapeo: [],
      zonaMapeando: null,
      zonasOtros: [],
      edited: null,
      paths: [],
      datosZonas: [],
      mvcPaths: null,
      errorMessage: null,
      polygonGeojson: "",
      itemEditando: null,
      pathsEditando: null,
      dialogEliminar: false,
      indexEliminar: null,
      loadingSave: false,
      itemMapeando: null,
      dialogMapeo: false,
      searchNeo: "",
      loadingNeo: false,
      loadingMapeo: false,
      selectedNeo: [],
      headersNeo: [
        {
          sortable: false,
          text: "Codigo",
          value: "Codigo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "Nombre",
        },
        {
          sortable: false,
          text: "Tipo",
          value: "Tipo",
        },
      ],
    };
  },
  watch: {
    dialogEliminar(val) {
      val || this.closeDialogEliminar();
    },
    polygonPaths: _.throttle(function (paths) {
      if (paths) {
        this.pathsEditando = paths;
        this.polygonGeojson = JSON.stringify(
          {
            type: "Polygon",
            coordinates: this.paths.map((path) =>
              closeLoop(path.map(({ lat, lng }) => [lng, lat]))
            ),
          },
          null,
          2
        );
      }
    }, 1000),
  },
  computed: {
    productosParaRecargo() {
      return this.productos.map((n) => {
        return {
          id: n.id,
          nombre: mostrarIdioma(n.nombre),
        };
      });
    },
    ...mapGetters({
      restGest: "app/restGestObj",
      negocioGest: "app/negocioGestObj",
      productos: "productos/getProductosListado",
    }),
    ...mapState({
      productosNeoNegocio: (state) => state.neo.productosNeo,
      productosNeoRestaurante: (state) =>
        state.neo.productosNeoRestauranteTodos,
    }),
    productosNeo() {
      if (this.negocioGest.mapeoNeoRestaurante === null) {
        //mapeo restuarnte
        var found = this.productosNeoRestaurante.find(
          (r) => r.id === this.$store.state.app.restauranteGest
        );
        return found ? found.productos : [];
      } else {
        return this.productosNeoNegocio;
      }
    },
    centro() {
      let r;
      if (this.restGest.latitud) {
        r = {
          lat: parseFloat(this.restGest.latitud),
          lng: parseFloat(this.restGest.longitud),
        };
      } else {
        r = {
          lat: 0,
          lng: 0,
        };
      }
      return r;
    },
    polygonPaths: function () {
      if (!this.mvcPaths) return null;

      let paths = [];
      for (let i = 0; i < this.mvcPaths.getLength(); i++) {
        let path = [];
        for (let j = 0; j < this.mvcPaths.getAt(i).getLength(); j++) {
          let point = this.mvcPaths.getAt(i).getAt(j);
          path.push({ lat: point.lat(), lng: point.lng() });
        }
        paths.push(path);
      }
      this.pathsEditando = _.flatten(paths);
      return paths;
    },
  },
  methods: {
    saveProductoRecargo() {
      this.zonaMapeando.productoRecargo = this.zonaParaRecargoProducto[0].id;
      this.close();
      console.log(this.datosZonas);
    },
    openDialogProductoZona(item) {
      this.paraRecargoDialog = true;
      this.zonaMapeando = item;
      console.log(item);
      if (item.productoRecargo) {
        let found = this.productosParaRecargo.find(
          (e) => e.id == item.productoRecargo
        );
        console.log(found);
        if (!!found)
          this.zonaParaRecargoProducto.push({
            id: found.id,
            nombre: found.nombre,
          });
      }
    },
    opciones(i) {
      let r = {
        fillColor: this.datosZonas[i].colorFondo,
      };
      return r;
    },
    opcionesOtros() {
      let r = {
        fillColor: "black",
      };
      return r;
    },
    goEditar(item, i) {
      this.datosZonas.forEach((d, i) => {
        d.editando = false;
        this.paths[i].editable = false;
      });
      item.editando = true;
      this.itemEditando = item;
      this.paths[i].editable = true;
      this.pathsEditando = this.paths[i];
    },
    showConfirm(i) {
      this.indexEliminar = i;
      this.dialogEliminar = true;
    },
    closeDialogEliminar() {
      this.dialogEliminar = false;
      this.indexEliminar = null;
    },
    removeZona() {
      _.pullAt(this.datosZonas, this.indexEliminar);
      _.pullAt(this.paths, this.indexEliminar);
      this.$forceUpdate();
      this.closeDialogEliminar();
    },
    saveZona(item, i) {
      item.editando = false;
      this.paths[i] = _.flatten(this.pathsEditando);
      this.paths[i].editable = false;
      this.itemEditando = null;
      this.pathsEditando = null;
    },
    updateEdited(mvcArray) {
      let paths = [];
      for (let i = 0; i < mvcArray.getLength(); i++) {
        let path = [];
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          let point = mvcArray.getAt(i).getAt(j);
          path.push({ lat: point.lat(), lng: point.lng() });
        }
        paths.push(path);
      }
      this.edited = paths;
    },
    updateCenter: function (place) {
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
    },
    updateEdited: function (mvcPaths) {
      this.mvcPaths = mvcPaths;
    },
    addPath: function () {
      // obtain the bounds, so we can guess how big the polygon should be
      var bounds = this.$refs.map.$mapObject.getBounds();
      var northEast = bounds.getNorthEast();
      var southWest = bounds.getSouthWest();
      var center = bounds.getCenter();
      var degree = this.paths.length + 1;
      var f = Math.pow(0.66, degree);

      // Draw a triangle. Use f to control the size of the triangle.
      // i.e., every time we add a path, we reduce the size of the triangle
      var path = [
        {
          lng: center.lng(),
          lat: (1 - f) * center.lat() + f * northEast.lat(),
        },
        {
          lng: (1 - f) * center.lng() + f * southWest.lng(),
          lat: (1 - f) * center.lat() + f * southWest.lat(),
        },
        {
          lng: (1 - f) * center.lng() + f * northEast.lng(),
          lat: (1 - f) * center.lat() + f * southWest.lat(),
        },
      ];
      let aux = {
        nombre: "desde datos",
        siDomicilio: true,
        siRecogida: true,
        domicilioMinimo: 0,
        domicilioRecargo: 0,
        recogidaMinimo: 0,
        recogidaRecargo: 0,
        editando: false,
        colorFondo: "blue",
      };
      path.editable = false;
      path.colorFondo = "green";
      this.datosZonas.push(aux);
      this.paths.push(path);
    },
    handleClickForDelete($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject
          .getPaths()
          .getAt($event.path)
          .removeAt($event.vertex);
      }
    },
    save() {
      this.loadingSave = true;
      let _vm = this;
      this.datosZonas.forEach((e, i) => {
        e.poligono = this.paths[i];
      });
      return this.$store
        .dispatch("restaurantes/saveZonasReparto", this.datosZonas)
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Zonas de reparto guardadas",
          });
        })
        .catch((e) => {
          console.log(e);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la zona de reparto",
          });
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    getZonas() {
      console.log(this.restGest);
      let zonasReparto = this.restGest.zonasReparto;
      if (zonasReparto) {
        zonasReparto = JSON.parse(JSON.stringify(zonasReparto));
        let zonas = [];
        zonasReparto.forEach((z) => {
          zonas.push(z.poligono);
          delete z.poligono;
        });
        this.datosZonas = zonasReparto;
        this.paths = zonas;
      }
    },
    getZonasOtrosRestaurantes() {
      let rests = JSON.parse(
        JSON.stringify(this.$store.state.restaurantes.restaurantesArray)
      );
      let otros = rests.filter((r) => r.id != this.restGest.id);
      otros.forEach((rObj) => {
        let zonaOtro = rObj.zonasReparto;
        if (zonaOtro) {
          let zonas = [];
          zonaOtro.forEach((z) => {
            zonas.push(z.poligono);
            delete z.poligono;
          });
          this.zonasOtros = [...this.zonasOtros, ...zonas];
        }
      });
    },
    getProductosNeo() {
      let _vm = this;
      this.loadingNeo = true;
      var accion;
      if (this.negocioGest.mapeoNeoRestaurante === null) {
        //mapeo restuarnte
        accion = this.$store.dispatch("negocios/getProductosNeoRestaurantes");
      } else {
        accion = this.$store.dispatch("negocios/getProductosNeo");
      }
      accion
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Productos Neo cargados",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al conectar con Neo: " + error,
          });
        })
        .finally(() => {
          this.loadingNeo = false;
        });
    },
    close() {
      this.dialogMapeo = false;
      this.paraRecargoDialog = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    openDialogMapeando(item) {
      this.dialogMapeo = true;
      this.zonaMapeando = item;
      if (item.mapeoNeoRecargo) {
        let found = this.productosNeo.find(
          (e) => e.Codigo == item.mapeoNeoRecargo
        );
        if (found) this.zonaMapeandoMapeo.push(found);
      }
    },
    saveMapeo() {
      this.zonaMapeando.mapeoNeoRecargo = this.zonaMapeandoMapeo[0].Codigo;
      this.close();
      console.log(this.datosZonas);
    },
    reiniciarDatos() {
      this.zonaMapeando = null;
      this.zonaMapeandoMapeo = [];
      this.zonaParaRecargoProducto = [];
    },
  },
  mounted() {
    this.getZonas();
    this.getZonasOtrosRestaurantes();
  },
};
</script>